export function transformSelectedItemsForQueryParam(items) {
  return items.length
    ? items.map((item) => {
        return {
          document_handlers: item.document_handlers.map((itm) =>
            itm.id ? itm.id : itm,
          ),
          id: item.id,
          is_movable: item.is_movable,
        };
      })
    : [];
}
